import { isLocalOrDevEnv } from '@/utils/helpers/env.ts'
import { useKeycloak } from '@/composables/auth/keycloak'

export function isDeepPayPaymentOrderEnabled() {
  return (
    isLocalOrDevEnv() ||
    import.meta.env.VITE_DEEPPAY_PAYMENT_ORDER_PAY_CLIENT_ENABLED === 'true'
  )
}

export function isDeepAEnabled() {
  const { isAuthenticated } = useKeycloak()

  return (
    import.meta.env.VITE_DEEPA_ENABLED === 'true' &&
    isLocalOrDevEnv() &&
    isAuthenticated.value
  )
}
